import React from "react"

import "../utils/resizer"

import Layout from "../components/layout"
import Seo from "../components/SEO"

import Intro from "../components/Intro/Intro"
import Info from "../components/Info/Info"
import Performances from "../components/Performances/Performances"
import Aboutus from "../components/Aboutus/Aboutus"
import Projects from "../components/Projects/Projects"
import Contact from "../components/Contact/Contact"

const home = ({ path, location }) => (
  <Layout path={path} location={location}>
    <Seo
      title="Home"
      keywords={[
        `SAL Service GmbH, Hausmeister, Hausmeisterservice, Erding, Freising, Reinigungsarbeiten, Gartenpflege, Renovierungsarbeiten, Gartenpflege, Mäharbeiten, Pflege, privat, Grundstück, Haus`,
      ]}
    />
    <Intro />
    <Info />
    <Performances />
    <Aboutus />
    <Projects />
    <Contact />
  </Layout>
)
export default home
